<div class="modal fade show" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title"> {{ 'meetings.Link Slide to Agenda Item' | translate }} </h4>

        <button type="button" class="close" aria-label="Close" (click)="closePop()">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="link-agenda-list">
          <div class="title">{{'meetings.AgendaItems' | translate}}</div>

          <mat-radio-group [(ngModel)]="agendaItemId" [ngModelOptions]="{standalone: true}">
            <mat-radio-button [value]="item.agendaItemEntityId" *ngFor="let item of agendItems">
              {{item.title}}
            </mat-radio-button>
          </mat-radio-group>

          <mat-error *ngIf="!agendaItemId && isSubmited">{{ 'messages.required' | translate }}</mat-error>
        </div>


        <div class="modal-btns mt-5">
          <button type="reset" class="close closebtn" (click)="closePop()">
            {{ 'swalMsg.cancel' | translate }}
          </button>
          <button mat-raised-button class="btn customBtn px-4" (click)="save()"
            [disabled]="loading" [ngClass]="{ 'loading': loading}">
            {{ 'meetings.Link Slide' | translate }}
          </button>
        </div>

      </div>

    </div>
  </div>
</div>
